import React from 'react';
import styles from './NoAccess.module.scss';
import Button from '../../components/button/Button';
import { useNavigate } from 'react-router-dom';

const NoAccess = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <h1>403</h1>
      <h2>Access Denied</h2>
      <h3>You do not have permission to view this page.</h3>
      <Button
        label='Go to Home'
        onClick={() => navigate('/')}
      />
    </div>
  );
};

export default NoAccess;